// src/services/TagsService.js
import axios from 'axios'

// must match your API root
const apiClient = axios.create({
  baseURL: 'https://dashamajig.chibitronics.com/api',
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  }
})

export default {
  /**
   * Search for tags matching `q`.
   * Expects your backend to accept GET /api/tags?q=foo
   * and return an array of strings (or objects you can map to strings).
   */
  search(q) {
    return apiClient.get('/tags', {
      params: { q }
    })
  },

  /**
   * Persist a new tag in the registry (available before any contact uses it).
   */
  create(tag) {
    return apiClient.post('/tags', { name: tag })
  },

  summary(q = '') {
    return apiClient.get('/tags/summary', { params: { q } })
  },

  rename(from, to) {
    return apiClient.patch('/tags/rename', { from, to })
  },

  remove(name) {
    return apiClient.delete('/tags', { params: { name } })
  },

  setMembership(name, customerIds) {
    return apiClient.put('/tags/membership', {
      name,
      customer_ids: customerIds
    })
  }
}

